export const helpCenterSearchAdapter = (data, selectedSection) => {
  const arr = Array.isArray(data) ? data : [];

  return selectedSection?  arr.filter((item) => item.section.slug === selectedSection).map((item) => {
    const rawSection = item?.section?.section ?? item?.section ?? {};
    const rawPages = item?.pages ?? item?.section?.pages ?? [];

    return {
      section: {
        title: rawSection?.caption ?? '',
        slug: rawSection?.slug ?? '',
      },
      pages: (Array.isArray(rawPages) ? rawPages : []).map((i) => ({
        caption: i?.page?.caption ?? i?.page?.slug ?? '',
        description: i?.page?.description ?? '',
        slug: `${rawSection?.slug ?? ''}/${i?.subsection?.slug ?? ''}/${i?.page?.slug ?? ''}`,
      })),
    };
  }) : arr.map((item) => {
    const rawSection = item?.section?.section ?? item?.section ?? {};
    const rawPages = item?.pages ?? item?.section?.pages ?? [];

    return {
      section: {
        title: rawSection?.caption ?? '',
        slug: rawSection?.slug ?? '',
      },
      pages: (Array.isArray(rawPages) ? rawPages : []).map((i) => ({
        caption: i?.page?.caption ?? i?.page?.slug ?? '',
        description: i?.page?.description ?? '',
        slug: `${rawSection?.slug ?? ''}/${i?.subsection?.slug ?? ''}/${i?.page?.slug ?? ''}`,
      })),
    };
  });
};
